import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "sidebar_collapsed"
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60

export default class extends Controller {
  static targets = ["content", "collapseIcon", "expandIcon"]
  static values = { expandedClass: String, collapsedClass: String }

  connect() {
    this.#pinToViewport()
  }

  toggle() {
    const collapsed = !this.element.classList.contains(this.collapsedClassValue)
    this.element.style.transition = "width 200ms"
    this.element.offsetHeight // force reflow so browser registers transition before width change
    this.element.addEventListener("transitionend", () => {
      this.element.style.transition = ""
    }, { once: true })
    this.#setCookie(collapsed)
    this.#apply(collapsed)
  }

  #pinToViewport() {
    const bodyPadding = getComputedStyle(document.body).paddingTop
    this.element.style.top = bodyPadding
    this.element.style.height = `calc(100vh - ${bodyPadding})`
  }

  #setCookie(collapsed) {
    document.cookie = `${COOKIE_NAME}=${collapsed}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`
  }

  #apply(collapsed) {
    this.contentTargets.forEach(el => el.classList.toggle("hidden", collapsed))
    this.collapseIconTarget.classList.toggle("hidden", collapsed)
    this.expandIconTarget.classList.toggle("hidden", !collapsed)
    this.element.classList.toggle(this.expandedClassValue, !collapsed)
    this.element.classList.toggle(this.collapsedClassValue, collapsed)
  }
}
